import { getLength, getArea} from 'ol/sphere'

export function copy (str) {
  return new Promise((resolve, reject) => {
    try {
      const el = document.createElement('textarea')
      el.value = str
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      const successful = document.execCommand('copy')
      document.body.removeChild(el)
      if (successful) {
        resolve()
      } else {
        reject(Error(successful))
      }
    } catch (err) {
      reject(err)
    }
  })
}

function file (fn, data) {
  const e = document.createEvent('MouseEvent')
  const a = document.createElement('a')
  e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
  a.setAttribute('href', data)
  a.setAttribute('download', fn)
  a.dispatchEvent(e)
  return false
}

// convert radians to degrees
export function radToDeg (rad) {
  return rad * 360 / (Math.PI * 2);
}

// convert degrees to radians
export function degToRad (deg) {
  return deg * Math.PI * 2 / 360;
}

export function scaleFactor (lonlat) {
  return (1 / Math.cos(degToRad(lonlat[1])))
}

// parse url
export function parseURL (href) {
  const match = href.match(/^(?:(https?:)\/\/)?(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7],
    query: parseSearch(match[6])
  }
}

export function validURL (href) {
  const match = href.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
  return (match !== null)
}

export function makeLink (text) {
  return String(text).replace(
    /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g,
    '<a href="$1" target="_blank">$1</a>'
  )
}

export function constructURL (parsedURL) {
  const querystring = serialize(parsedURL.query)
  return parsedURL.protocol + '//' + parsedURL.host + parsedURL.pathname + '?' + querystring;
}

export function serialize (query) {
  return Object.keys(query).map(item => {
    return item + '=' + query[item]
  }).join('&')
}

export function uid () {
  return Math.random().toString(36).substr(2, 10)
}

export function getRandomColor (conf) {
  return randomColor(conf)
}

export function hexToRgbA (hex, a) {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = '0x' + c.join('')
    return 'rgba(' + [(c>>16)&255, (c>>8)&255, c&255].join(',') + ',' + a + ')'
  }
  throw new Error('Bad Hex')
}

export function colorFromArray (arr) {
  if (arr.length === 3) {
    return 'rgb(' + arr.join(',') + ')'
  }
  if (arr.length === 4) {
    return 'rgba(' + arr.join(',') + ')'
  }
  throw new Error('Bad Array')
}

export function formatLength (line, length, decimals = [2, 2]) {
  if (!length) {
    length = getLength(line)
  }
  if (length > 10000) {
    const roundFactor = Math.pow(10, decimals[0])
    return `${(Math.round(length / 1000 * roundFactor) / roundFactor)} km`
  } else {
    const roundFactor = Math.pow(10, decimals[1])
    return `${(Math.round(length * roundFactor) / roundFactor)} m`
  }
}

export function formatArea (polygon, area, decimals = [2, 2]) {
  if (!area) {
    area = getArea(polygon)
  }
  if (area > 1000000) {
    const roundFactor = Math.pow(10, decimals[0])
    return `${(Math.round(area / 1000000 * roundFactor) / roundFactor)} km<sup>2</sup>`
  } else {
    const roundFactor = Math.pow(10, decimals[0])
    return `${(Math.round(area * roundFactor) / roundFactor)} m<sup>2</sup>`
  }
}

export function formatDate (time, short = false) {
  const d = new Date(time)
  let month = (1 + d.getMonth()).toString()
  month = month.length > 1 ? month : '0' + month
  let day = d.getDate().toString()
  day = day.length > 1 ? day : '0' + day
  return short ? day + '.' + month : d.getFullYear() + '.' + month + '.' + day
}

export function formatTime (s) {
  return new Date(s).toTimeString().slice(0, 8)
}

export function deepCopy (json) {
  return JSON.parse(JSON.stringify(json))
}
